export default {
    computed: {
        wamlyIntegrationIsEnabled() {
            return this.$auth.user?.company?.uses_wamly;
        },
    },

    methods: {
        jobIsLinkedToWamly(job) {
            return Boolean(job?.wamly_project);
        },
    },
};
